import * as React from 'react'

import('./VideoOptionsStyles.scss')


const VideoOptionsPresentation = (props:any) => {
    return (
        <div>
            <h1>VIDEO OPTIONS</h1>
            <table>
                <tbody>
                    {Object.keys(props.videoOptions).map( (key:string, index:number) =>
                    <tr key={index}>
                        <th style={{textAlign: 'right'}}>{key} -&gt;</th>
                        <td>{props.videoOptions[key]}</td>
                    </tr>
                        )}
                </tbody>
            </table>
        </div>
    )
}

export default VideoOptionsPresentation;
